import * as ex from 'excalibur';
import { GRID_WIDTH, GRID_HEIGHT, TILE_SIZE } from './config/constants';
import { Game } from './game';

// Create the Excalibur game engine
const engine = new ex.Engine({
  width: GRID_WIDTH * TILE_SIZE,
  height: GRID_HEIGHT * TILE_SIZE + 100, // Extra space for UI
  backgroundColor: ex.Color.fromHex('#f0f0f0'),
  displayMode: ex.DisplayMode.FitScreen
});

// Add the main game scene
const game = new Game();
engine.add('game', game);

// Start with the game scene
engine.goToScene('game');

// Start the game engine
engine.start();